module.exports = __webpack_public_path__ + "static/media/kim-sehyun.8f0c5a85.png";